<template>
  <div class="wrapper w-100">
    <el-table
        :data="items"
        class="w-100"
    >
      <el-table-column
          prop="id"
          label="ID"
          sortable
          width="80"
      ></el-table-column>
      <el-table-column
          prop="user"
          label="User"
          width="170"
          :formatter="formatUserRow"
      ></el-table-column>
      <el-table-column
          prop="read_only"
          label="Read Only"
          width="100"
          v-slot="{row: {read_only}}"
      >
        <read-only-column :read-only="read_only"></read-only-column>
      </el-table-column>
      <el-table-column
          prop="note"
          label="Note"
          v-slot="{row: {note}}"
      >
        <div class="message message-body" v-text="note"></div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ReadOnlyColumn from './columns/read-only-column';

export default {
  components: {
    ReadOnlyColumn,
  },

  props: {
    items: Array,
  },

  methods: {
    /**
     * @param row
     * @param col
     * @param {Object} user
     */
    formatUserRow(row, col, user) {
      return `${user.full_name}`;
    }
  },
}
</script>
